import React, { useMemo, useRef, useState } from 'react';

import { QuickFindSkeleton as QuickFindSkeletonInternal } from '@atlassian/search-page/quick-find-skeleton';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';

import { getPersistedGhostText } from './utils/getPersistedGhostText.ts';
import { createQuickFindSkeletonOnEnter } from './utils/createQuickFindSkeletonOnEnter.ts';

export const QuickFindSkeleton = (): React.JSX.Element => {
	const { push } = useRouteActions();
	const inputRef = useRef<HTMLInputElement>(null);
	const [customPlaceholder] = useState(() => getPersistedGhostText(inputRef));

	const onEnter = useMemo(() => createQuickFindSkeletonOnEnter(push), [push]);
	return (
		<QuickFindSkeletonInternal
			onEnter={onEnter}
			isNav4Enabled
			primaryProduct="confluence"
			customPlaceholder={customPlaceholder}
			inputRef={inputRef}
		/>
	);
};

export const QuickFindAsync: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-QuickFind" */ './QuickFind.tsx')).QuickFind,
	loading: () => <QuickFindSkeleton />,
});
